export const teamRouteNames = {
   TEAM_MEMBERS: 'team-members',
   ROLES: 'role-templates',
   REPORT: 'report',
   COMPETENCIES: 'competencies',
   PERFORMANCE_EVALUATIONS: 'performance-evaluations'
};
